// extracted by mini-css-extract-plugin
export default {"emptyContainer":"EmptyData_emptyContainer__6Wtq6"};